import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import SectionLabelWithIcon from 'components/typography/SectionLabelWithIcon';
import { ReactComponent as PriceTag } from 'images/icons/pricetag.svg';

export default function Price({ className = '', updateInView, price }) {
  const [ref, inView] = useInView({ threshold: 0.1 });

  useEffect(() => {
    updateInView(inView);
  }, [inView, updateInView]);

  const priceFormatter = () => {
    if (price) {
      const priceData = JSON.parse(price.replace(/'/g, '"'));
      return priceData.total.toLocaleString('en-US', {
        style: 'currency',
        currency: priceData.currency,
      });
    }
    return '-';
  };

  return (
    <div
      className={`${className} relative z-[10] mt-[80px]`}
      id="price"
      ref={ref}
    >
      <SectionLabelWithIcon
        label="Price"
        icon={<PriceTag />}
        iconContainerClassName="section-icon"
      />
      <div className="pt-9">
        <div className="border-b mb-4">
          <div className="pb-2 flex justify-between">
            <div className="grow font-medium text-[22px]">Total</div>
            <div className="font-medium text-[22px]">{priceFormatter()}</div>
          </div>
        </div>
        <div className="flex justify-between">
          <div className="grow">
            To pay a deposit or the full amount for your holiday, please call
            your travel specialist. We accept payments by direct debit, credit
            card or bank transfer.
          </div>
          <div className="xs:min-w-[160px]" />
        </div>
      </div>
    </div>
  );
}
